export default {"FittSelector.nooptions":{"en":"No match","fr":"Aucune correspondance"}}